import type { InquiryFormData } from "../../../../hooks/use-inquiries";

const getProgramId = (selectedSubService?: string) => selectedSubService?.split("::")[0];

export const hasServiceOrSubserviceChanged = (baseline: InquiryFormData, current: InquiryFormData): boolean => {
  return (
    baseline.serviceId !== current.serviceId ||
    getProgramId(baseline.selectedSubService) !== getProgramId(current.selectedSubService)
  );
};
